export const isDev = typeof import.meta !== 'undefined' && import.meta.env
    ? import.meta.env.VITE_ENV === 'development'
    : process.env.VITE_ENV === 'development';

const devUrl =
    typeof import.meta !== 'undefined' && import.meta.env
        ? import.meta.env.VITE_LOCAL_SERVER_URL ?? 'http://api.ileratravelhealth.test:4000'
        : process.env.VITE_LOCAL_SERVER_URL ?? 'http://api.ileratravelhealth.test:4000';

const prodUrl =
    typeof import.meta !== 'undefined' && import.meta.env
        ? import.meta.env.VITE_SERVER_PROD_URL ?? import.meta.env.VITE_API_URL ?? 'https://api.ileratravelhealth.com'
        : process.env.VITE_SERVER_PROD_URL ?? process.env.VITE_API_URL ?? 'https://api.ileratravelhealth.com';

export const url = isDev ? devUrl : prodUrl

export const image_url_gen = (path) => {
    if (!path) {
        return '';
    }

    if (path.includes("https")) {
        return path;
    }

    return `${url}/${path}`;
}
